import React, { useEffect, useState } from "react";
import {
  Grid,
  BreadCrumbBox,
  FilterWraper,
  Section,
  Button,
  Badge,
  Tabel,
  Loading,
} from "../../core";
import { Row } from "antd";
import { getCompanySendYarn } from "../../helper/utils/api/sizer";
import { getCompanyId } from "../../helper/utils/companyId";

const CHANGE_DATE_FORMAT = require("../../helper/utils/datFormat");

const btnProps = {
  width: "149px",
  height: "40px",
  weight: "600",
  fontSize: "16px",
  margin: "10px",
};

const columns = [
  {
    title: "SR #",
    dataIndex: "SNo",
    key: "S.No",
    width: 150,
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "key",
    render: (text, record) => (
      <span>{CHANGE_DATE_FORMAT.changeDateFormat(record.date)}</span>
    ),
    width: 150,
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: 150,
  },
  {
    title: "Quality",
    dataIndex: "quality",
    key: "quality",
    width: 150,
  },
  {
    title: "Yarn Sent",
    dataIndex: "yarn_sent",
    key: "yarn_sent",
    width: 150,
  },
  {
    title: "Yarn Consumed",
    dataIndex: "yarn_consumed",
    key: "yarn_consumed",
    width: 150,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 150,
    render: (text) => <Badge status={text} text={text} />,
  },
];

const YarnStockHistory = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      const companyId = getCompanyId();
      if (!companyId) return;
      setIsLoading(true);
      try {
        const { data } = await getCompanySendYarn(companyId);
        setRows(Array.isArray(data) ? data : []);
      } catch (error) {
        console.log("yarn stock history error", error);
        setRows([]);
      }
      setIsLoading(false);
    };
    load();
  }, []);

  return (
    <Grid>
      <BreadCrumbBox tittle="Yarn Stock History" />
      <Section className="mb-50">
        {isLoading ? <Loading /> : null}
        <FilterWraper>
          <Tabel nowidth={false} padding="0px" columns={columns} data={rows} />
        </FilterWraper>
        <Row type="flex" justify="end">
          <Button
            {...btnProps}
            bg="white"
            color="#FF5687"
            border="1px solid #FF5687"
          >
            Export
          </Button>
          <Button {...btnProps} bg="#FF5687">
            Print
          </Button>
        </Row>
      </Section>
    </Grid>
  );
};

export default YarnStockHistory;
